import edit from './edit';

export default (permissions) => {
  return {
    name: 'eventEvidence',
    edit: edit,
    icon: 'search',
    options: {
      isHidden: true
    },
  };
};
